export const LOGIN_SIGNUP_FIELD_CLICKED = 'Login - Signup field clicked';
export const ONBOARDING_GOAL_SELECTED = 'Onboarding - Goal Selected';
export const ONBOARDING_START_LEARNING_CLICKED =
  'Onboarding - Start Learning Clicked';
export const GOAL_SEARCH_SEARCH_CLICKED = 'Goal Search - Search Clicked';
export const GOAL_SEARCH_RESULT_CLICKED = 'Goal Search - Result Clicked';
